var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "mx-auto",
      staticStyle: { "max-width": "400px", "margin-top": "10vh" },
      attrs: { elevation: "4" }
    },
    [
      _c(
        "v-toolbar",
        { attrs: { color: "indigo", dark: "" } },
        [
          _c(
            "v-card-title",
            {
              staticClass: "pa-0",
              staticStyle: { "-webkit-app-region": "drag" }
            },
            [_c("span", [_vm._v("Welcome")])]
          ),
          _c("v-spacer"),
          _c("v-icon", [_vm._v("mdi-briefcase")])
        ],
        1
      ),
      _c(
        "v-container",
        { staticStyle: { "-webkit-app-region": "no-drag" } },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _vm._l(_vm.loginPostErrors, function(item, index) {
                    return _c(
                      "v-alert",
                      {
                        key: index,
                        staticClass: "py-0 text-uppercase",
                        attrs: {
                          dense: "",
                          type: "error",
                          outlined: "",
                          text: "",
                          dismissible: "",
                          transition: "slide-x-transition"
                        }
                      },
                      [_vm._v(" " + _vm._s(item.first()) + " ")]
                    )
                  }),
                  _c("v-text-field", {
                    attrs: {
                      "prepend-icon": "mdi-account",
                      label: "Username",
                      required: ""
                    },
                    model: {
                      value: _vm.name,
                      callback: function($$v) {
                        _vm.name = $$v
                      },
                      expression: "name"
                    }
                  })
                ],
                2
              ),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      type: !_vm.showPassword ? "password" : "text",
                      label: "Password",
                      "prepend-icon": "mdi-lock",
                      "append-icon": !_vm.showPassword
                        ? "mdi-eye"
                        : "mdi-eye-off",
                      required: ""
                    },
                    on: {
                      "click:append": function($event) {
                        _vm.showPassword = !_vm.showPassword
                      }
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "indigo",
                        loading: _vm.loginPosting,
                        dark: ""
                      },
                      on: { click: _vm.login }
                    },
                    [_vm._v(" Login ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }